import { render, staticRenderFns } from "./ServiceDashboard.vue?vue&type=template&id=6d9a75c3&"
import script from "./ServiceDashboard.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d9a75c3')) {
      api.createRecord('6d9a75c3', component.options)
    } else {
      api.reload('6d9a75c3', component.options)
    }
    module.hot.accept("./ServiceDashboard.vue?vue&type=template&id=6d9a75c3&", function () {
      api.rerender('6d9a75c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ServiceDashboard.vue"
export default component.exports